module.exports = __webpack_public_path__ + "static/media/last_getty_mobile.66deb909.jpg";